import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { Page } from '../components';
import { reactPlugin } from "../AppInsights";
import React from "react";
import { AccessRoles, useHasRole } from "../hooks/useHasRole";
import { useGetLanguage } from "../hooks/useGetLanguage";
import { useGetUserQuery } from "../services/msgraph/msGraphApi";
import { LabelMedium, ParagraphMedium, ParagraphSmall, ParagraphXSmall } from "baseui/typography";
import { Block } from "baseui/block";
import { Avatar } from "baseui/avatar";
import { useStyletron, withStyle } from "baseui";
import { StyledLink } from "baseui/link";
import { useMsal } from "@azure/msal-react";
import { ListItem, ListItemLabel } from "baseui/list";
import { apiConfig } from '../config';
import { getAccount } from "../msalConfig";

const UserDetails = () => {
    const { accounts } = useMsal();
    const [css, theme] = useStyletron();
    const hasSubscriptionAccess = useHasRole(AccessRoles.Subscription.Write);
    const { language } = useGetLanguage();
    const { data, isLoading, isSuccess, error } = useGetUserQuery();

    var myAccount = getAccount(accounts);
    const roles = myAccount?.idTokenClaims?.roles;
    return (
        <Page header='User Profile'>
            <Block marginTop={theme.sizing.scale1400} display={'flex'} flexDirection='column' gridGap={theme.sizing.scale1400}>
                <Block>
                <Block display={'inline-flex'} gridGap={theme.sizing.scale400} alignItems='center'><Avatar
                        name={data?.displayName}
                        size="scale1000"
                    />
                        <ParagraphMedium>{data?.displayName}</ParagraphMedium>
                    </Block>
                    <ParagraphMedium>{myAccount?.username}</ParagraphMedium>
                    <ParagraphXSmall>ObjectId: {data?.id}</ParagraphXSmall>
                    <ParagraphMedium>Language: {language}</ParagraphMedium>
                </Block>
                {hasSubscriptionAccess && <Block>
                    <StyledLink href={apiConfig.subscriptionPortalUrl} target={'_blank'}>Goto Subscription Administration Portal</StyledLink>
                </Block>}
                <ParagraphSmall marginTop={theme.sizing.scale400} color={theme.colors.contentTertiary}>
                    By using this App you aggree to the <GrayStyledLink href="https://oqdo.io/terms-and-conditions/">Terms and Conditions</GrayStyledLink>
                    {' '}and the <GrayStyledLink  href="https://oqdo.io/oqdobos-privacy/">Privacy Policy</GrayStyledLink>
                </ParagraphSmall>

                <Block>
                    <LabelMedium>Access Roles</LabelMedium>
                    <ul
                        className={css({
                            width: '375px',
                            paddingLeft: 0,
                            paddingRight: 0,
                        })}
                    >
                        {roles?.sort((a, b) => (a < b ? -1 : 1)).map((role) => (<>
                            <ListItem sublist>
                                <ListItemLabel description={role}> </ListItemLabel>
                            </ListItem></>))}
                    </ul>
                </Block>

            </Block>
        </Page >
    )
}


export default React.memo(withAITracking(reactPlugin, UserDetails));


const GrayStyledLink = withStyle(StyledLink,({$theme}) => ({
    color: $theme.colors.contentTertiary
}))